import { Badge, Group } from '@mantine/core';

import { ViewExternalIdBadgeList } from '#plugin-chat/components/tool-display/ViewExternalIdBadge.tsx';

export interface ToolCompleteBadgesProps {
  /** The source data key (displayed with outline style) */
  inputDataset?: string;
  /** The output data key (displayed with arrow prefix and outline style) */
  outputDataset?: string;
  /** Row count (displayed with light variant) */
  rowCount?: number;
  /** Optional truncation count */
  truncatedRows?: number;
  /** Badge color for row count (default: blue.4) */
  rowCountColor?: string;
}

export function ToolCompleteBadges({
  inputDataset,
  outputDataset,
  rowCount,
  truncatedRows,
  rowCountColor = 'blue.4',
}: ToolCompleteBadgesProps) {
  return (
    <Group align="center" gap="xs">
      {inputDataset && <ViewExternalIdBadgeList externalIds={[inputDataset]} />}
      {outputDataset && <ViewExternalIdBadgeList externalIds={[`→ ${outputDataset}`]} />}
      {rowCount !== undefined && (
        <Badge color={rowCountColor} size="xs" variant="light">
          {rowCount} rows
          {truncatedRows ? ` (${truncatedRows} truncated)` : ''}
        </Badge>
      )}
    </Group>
  );
}
